import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement, LineController, BarController } from 'chart.js';
import { Chart, Pie } from 'react-chartjs-2';
import ActionTypes from '../../store/actionTypes';
import { useCentralStore } from '../../store/appContext';
import { Progress } from 'antd';

// import SwapConfirmed from '../../assets/images/SwapConfirmed.png'
// import SwapDelivered from '../../assets/images/SwapDelivered.png'
// import ReplaceConfirmed from '../../assets/images/ReplaceConfirmed.png'

import SwapConfirmed from '../../assets/images/Swap_Confirmed.png'
import SwapDelivered from '../../assets/images/Swap_Delivered.png'
import ReplaceConfirmed from '../../assets/images/Replace_Confirmed.png'
import ReplaceDelivered from '../../assets/images/Replace_Delivered.png'

import { color } from 'chart.js/helpers';
import { getApplicableSections } from '../../utils/functionUtils';
import { getCarrierByDomain } from '../../domain';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    LineController,
    BarController
);

ChartJS.register(ArcElement, Tooltip, Legend);


const ProgramSummary = () => {

    const [{ chartReportCountSuccess, carrierThemeData }, dispatch] = useCentralStore()
    const { theme } = carrierThemeData;

    //const date = new Date()
    //const prevMonth = date?.getFullYear() + `${date?.getMonth() > 9 ? '-' : '-0'}` + date?.getMonth()
    const date = new Date();
    const currentMonth = date.getMonth(); // Get the current month (0-11)
    const currentYear = date.getFullYear(); // Get the current year

    // Determine previous month and year
    let month, year;

    if (currentMonth === 0) { // If it's January
        month = 12; // December of the previous year
        year = currentYear - 1; // Decrease the year by 1
    } else {
        month = currentMonth; // Current month minus 1
        year = currentYear; // Keep the same year
    }

    const prevMonth = year + `${month > 9 ? '-' : '-0'}` + month

    const customerSLA = chartReportCountSuccess?.CustomerServiceSLA[prevMonth]
    const technicalSLA = chartReportCountSuccess?.TechnicalSLA[prevMonth]

    const serviceRequestReportCount = chartReportCountSuccess?.ServiceRequestReportCount?.filter(v => v?.Month === prevMonth)
    const acceptedCnt = Number(serviceRequestReportCount?.[0]?.['Accepted Service Requests']) || 0
    const cancelledCnt = Number(serviceRequestReportCount?.[0]?.['Canceled Service Requests']) || 0
    const rejectedCnt = Number(serviceRequestReportCount?.[0]?.['Rejected Service Requests']) || 0

    const totalServiceRequestReportCount = acceptedCnt + cancelledCnt + rejectedCnt
    const acceptedPer = ((acceptedCnt / totalServiceRequestReportCount) * 100) > 0 ? ((acceptedCnt / totalServiceRequestReportCount) * 100).toFixed(2) : 0
    const cancelledPer = (cancelledCnt / totalServiceRequestReportCount) * 100 > 0 ? ((cancelledCnt / totalServiceRequestReportCount) * 100).toFixed(2) : 0
    const rejectedPer = (rejectedCnt / totalServiceRequestReportCount) * 100 > 0 ? ((rejectedCnt / totalServiceRequestReportCount) * 100).toFixed(2) : 0

    const optionsPieChart = {
        responsive: true,
        plugins: {
            legend: {
                position: "right",
                labels: {
                    usePointStyle: true,
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    return value > 0 ? value + '%' : null;
                },
                // align: "center",
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 900,
                        color: 'white',
                        size: 24,
                    }
                },
            }
        }
    };


    const dataPieChartSR = {
        labels: ['Accepted %', 'Rejected %', 'Cancelled %'],
        datasets: [
            {
                label: '',
                data: [acceptedPer, rejectedPer, cancelledPer],
                backgroundColor: [
                    theme?.colors?.pieChartColors[0],
                    theme?.colors?.pieChartColors[1],
                    theme?.colors?.pieChartColors[2]
                ],
                borderColor: [
                    '#fff',
                    '#fff',
                    '#fff'
                ],
                borderWidth: 4,
                fontColor: 'white'
            },
        ],
    };

    const npsCurrentMonth = chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === prevMonth)?.length > 0 ? chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === prevMonth) : chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === '2022-12')

    const _npsPrevMonth = date?.getFullYear() + `${date?.getMonth() > 9 ? '-' : '-0'}` + (date?.getMonth() - 1)
    const npsPrevMonth = chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === _npsPrevMonth)?.length > 0 ? chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === _npsPrevMonth) : chartReportCountSuccess?.NPSCount?.filter(v => v?.Month === '2022-10')
    let getBgColor = theme?.colors?.monthlyTrendsTab?.chartColors //{0: '#1ED760', 1: '#685BC7', 2: '#C800A1', 3: '#500878', 4: '#1CD4B0', 5: '#09411D', 6: '#8CBDFA', 7: '#C800A1', 8: '#8A2252', 9: '#878787', 10: '#DC3545', 11: '#1ED760'}
    let labels = [_npsPrevMonth, prevMonth]

    const npsTrendChart = {
        labels,
        datasets: [
            {
                type: 'line',
                label: 'NPS KPI',
                borderColor: getBgColor[2],
                borderWidth: 2,
                fill: false,
                data: [60, 60],
            },
            {
                type: 'bar',
                label: 'Survey Completion Rate',
                backgroundColor: getBgColor[1],
                // data: [npsPrevMonth?.[0]?.OnlineNpsCount || 0, npsCurrentMonth?.[0]?.OnlineNpsCount || 0],
                data: [npsPrevMonth?.[0]?.TotalCount || 0, npsCurrentMonth?.[0]?.TotalCount || 0],
                borderColor: 'white',
                borderWidth: 2,
            },
            {
                type: 'bar',
                label: "NPS",
                data: [80, 90],
                backgroundColor: getBgColor[0],
                stack: 1,
                borderRadius: 10,
                // barThickness: 14
            },
        ],
    }


    const npsTrendChartOptions = {
        plugins: {
            title: {
                display: false,
                text: 'NPS Trend',
            },
            legend: {
                position: "right",
                labels: {
                    usePointStyle: true,
                    font: {
                        size: 10,
                        weight: 700
                    }
                },
            },
            datalabels: {
                formatter: function (value, context) {
                    return context?.dataset?.label === 'Survey Completion Rate' ? value + '%' : value;
                },
                align: "top",
                labels: {
                    usePointStyle: true,
                    font: {
                        weight: 700,
                        color: 'black',
                        size: 16,
                    }
                },
            }
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const dynamicSRDurationStyle = {
        '--duration-chart-color1': theme?.colors?.primary,
        '--duration-chart-color2': theme?.colors?.primary,
        '--circleborder-color': theme?.colors?.primary,
    }

    return (
        <div className='flex flex-wrap justify-center gap-5 pb-5 w-full pgmSummary mt-5'>
            {getApplicableSections(carrierThemeData?.applicableSections, 'ServiceRequests') &&
                <div className='flex flex-col items-center w-[49%] border border-[#D9D9D9] rounded-xl px-4'>
                    <p className='p-2 w-full text-[#363636] font-semibold text-xl'>Service Requests</p>
                    <div className=''>
                        <Pie data={dataPieChartSR} options={optionsPieChart} />
                    </div>
                </div>
            }
            {/* <div className='w-[30%] shadow-xl rounded-xl p-4 pb-0'>
                <p className='p-2 w-full text-black text-xl'>NPS Score</p>
                <div className='flex justify-between items-center mt-12 mx-5 2xl:w-[65%] 2xl:mx-auto'>
                    <div className=''>
                        <Progress 
                            type="circle" 
                            percent={npsCurrentMonth?.[0]?.OnlineNpsCount} 
                            strokeWidth={10} 
                            strokeColor={{ '0%': theme?.colors?.progressBar?.primaryColor, '100%': theme?.colors?.progressBar?.secodaryColor }} 
                            size={170} format={(percent) => `${percent}`} 
                        />
                    </div>
                    <div className=''>
                        <p className='text-black text-sm mb-5 font-semibold'>Completion rate 42%</p>
                        <p className='text-black text-sm font-semibold'>{npsCurrentMonth?.[0]?.TotalCount} respondents</p>
                    </div>
                </div>
            </div> */}
            <div className='flex flex-col items-center w-[49%] border border-[#D9D9D9] rounded-xl px-4 pb-4'>
                <p className='p-2 w-full text-xl text-[#363636] font-semibold'>Customer SLA</p>
                <div className='flex flex-row mx-2 items-start w-full'>
                    {/* Left Column */}
                    <div className={`${getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'mt-5' : 'mt-10'} flex flex-col w-full mx-2`}>
                        {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummarySRAcceptanceRejection') &&
                            <div className={`flex flex-col items-center justify-center ${customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                            <Progress
                                percent={customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ActualSLA%']}
                                size={['100%', 40]}
                                strokeColor={
                                    customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ActualSLA%'] <
                                        customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ExpectedSLA%']
                                        ? { '0%': '#E553D0', '100%': '#C800A1' }
                                        : { '0%': 'black', '100%': 'black' }
                                }
                                format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                percentPosition={{
                                    align: customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                    type: customerSLA?.filter(v => v?.Category === 'Acceptance/ Rejection of Service Requests with communication to Subscriber')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                  }}
                            />
                            <p className='h-[30px] text-black text-[14px] mt-1 text-center'>Service Request Acceptance/Rejection</p>
                        </div>
                        }
                        <div className={`flex flex-col items-center justify-center ${(customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ActualSLA%']  > 0 || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ActualSLA%'] > 0) ? 'SLASection' : 'SLASectionNA'} ${getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummarySRAcceptanceRejection') ? 'mt-5' : ''}`}>
                            <Progress
                                percent={customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ActualSLA%'] || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ActualSLA%']}
                                size={['100%', 40]}
                                strokeColor={
                                    (customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ActualSLA%'] || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ActualSLA%']) <
                                        (customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ExpectedSLA%'] || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ExpectedSLA%'])
                                        ? { '0%': '#E553D0', '100%': '#C800A1' }
                                        : { '0%': 'black', '100%': 'black' }
                                }
                                format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                percentPosition={{
                                    align: (customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ActualSLA%']  > 0 || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ActualSLA%'] > 0) ? 'center' : undefined,
                                    type: (customerSLA?.filter(v => v?.Category === 'Delivery')[0]?.['ActualSLA%']  > 0 || customerSLA?.filter(v => v?.Category === 'Ontime Delivery')[0]?.['ActualSLA%'] > 0) ? 'inner' : undefined,
                                  }}
                            />
                            <p className='h-[30px] text-black text-[14px] mt-1 text-center'>{getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'On-Time Delivery' : 'Delivery'}</p>
                        </div>
                        {getApplicableSections(carrierThemeData?.applicableSections, 'Hotlinegradeofservice') &&
                        <div className='flex flex-col mt-5 w-full'>
                            <div className='flex flex-col items-center justify-center SLASection'>
                                <Progress
                                    percent={customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={
                                        customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%'] <
                                            customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ExpectedSLA%']
                                            ? { '0%': '#E553D0', '100%': '#C800A1' }
                                            : { '0%': 'black', '100%': 'black' }
                                    }
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    percentPosition={{
                                        align: customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                        type: customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                      }}
                                />
                                <p className='h-[30px] text-black text-[14px] text-center'>Hotline grade of service - ( Voice Channel )</p>
                            </div>
                        </div>
                    }
                    </div>

                    {/* Middle Column */}
                    <div className='flex flex-col mt-[22px] w-full mx-2'>
                        {/* {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummaryDeviceRepair') &&
                            <div className={`flex flex-col items-center justify-center ${customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                                <Progress
                                    percent={customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={
                                        customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ActualSLA%'] <
                                            customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ExpectedSLA%']
                                            ? { '0%': '#E553D0', '100%': '#C800A1' }
                                            : { '0%': 'black', '100%': 'black' }
                                    }
                                    percentPosition={{
                                        align: customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                        type: customerSLA?.filter(v => v?.Category === 'Device Repair')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                      }}
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                />
                                <p className='h-[30px] text-black text-[14px] text-center'>Device Repair (1 day delivery)</p>
                            </div>
                        } */}
                        <div className={`flex flex-col items-center justify-center ${customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'} ${getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummaryDeviceRepair') ? 'mt-[18px]' : 'mt-[-2px]'}`}>
                            <Progress
                                percent={customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ActualSLA%']}
                                size={['100%', 40]}
                                strokeColor={
                                    customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ActualSLA%'] <
                                        customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ExpectedSLA%']
                                        ? { '0%': '#E553D0', '100%': '#C800A1' }
                                        : { '0%': 'black', '100%': 'black' }
                                }
                                format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                percentPosition={{
                                    align: customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                    type: customerSLA?.filter(v => v?.Category === 'Customer complaints management')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                  }}
                            />
                            <p className='h-[30px] text-black text-[14px] mt-1 text-center'>Customer Complaints</p>
                        </div>
                    </div>

                    {/* Right Column */}
                    {/* {getApplicableSections(carrierThemeData?.applicableSections, 'Hotlinegradeofservice') &&
                        <div className='flex flex-col mt-10 w-full'>
                            <div className='flex flex-col items-center justify-center SLASection'>
                                <Progress
                                    percent={customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={
                                        customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ActualSLA%'] <
                                            customerSLA?.filter(v => v?.Category === 'Hotline grade of service - ( Voice Channel )')[0]?.['ExpectedSLA%']
                                            ? { '0%': '#E553D0', '100%': '#C800A1' }
                                            : { '0%': theme?.colors?.progressBar?.primaryColor, '100%': theme?.colors?.progressBar?.secodaryColor }
                                    }
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                />
                                <p className='h-[30px] text-black text-[14px] text-center'>Hotline grade of service - ( Voice Channel )</p>
                            </div>
                        </div>
                    } */}
                </div>
            </div>
            {getApplicableSections(carrierThemeData?.applicableSections, 'ServiceRequestsDuration') &&
                <div className='flex flex-col items-center w-[40%] shadow-xl rounded-xl p-4'>
                    <p className='p-2 w-full text-black text-xl'>Service Requests Duration</p>
                    <div className='m-5 w-full'>
                        <p className='text-black font-semibold'>Swap</p>
                        <div className='flex  w-full'>
                            <div className='relative top-[45%] left-[50%] z-50'>
                                <p className='!m-0 durationCircleCSS  text-center w-12 h-12 p-3 rounded-full'
                                    style={dynamicSRDurationStyle}>
                                    {chartReportCountSuccess?.TatData?.filter(v => v?.ClaimType === 'Swap')[0]?.['TAT']}
                                </p>
                                <p className='text-black text-[14px] text-center'>Days</p>
                            </div>
                            <div>
                                <div class="circleborder" style={dynamicSRDurationStyle}><img src={SwapConfirmed} className='srDurationStyleImg' /></div>
                                <p className='text-black text-[14px] text-center'>Claim Start</p>
                            </div>
                            <hr className='durationCircleCSS  w-full h-1 my-2 relative top-3 right-[1%]' style={dynamicSRDurationStyle} />
                            <div className='relative right-[2%]'>
                                <div class="circleborder" style={dynamicSRDurationStyle}><img src={SwapDelivered} className='srDurationStyleImg' /></div>
                                <p className='text-black text-[14px] text-center'>Delivered</p>
                            </div>
                        </div>
                    </div>
                    <div className='mt-5  w-full'>
                        <p className='text-black font-semibold'>Replace</p>
                        <div className='flex  w-full'>
                            <div className='relative top-[45%] left-[50%] z-50'>
                                <p className='!m-0 durationCircleCSS  text-center w-12 h-12 p-3 rounded-full' style={dynamicSRDurationStyle}>
                                    {chartReportCountSuccess?.TatData?.filter(v => v?.ClaimType === 'Replacement')[0]?.['TAT']}
                                </p>
                                <p className='text-black text-[14px] text-center'>Days</p>
                            </div>
                            <div>
                                <div class="circleborder" style={dynamicSRDurationStyle}><img src={ReplaceConfirmed} className='srDurationStyleImg' /></div>
                                <p className='text-black text-[14px] text-center'>Claim Start</p>
                            </div>
                            <hr className='durationCircleCSS  w-full h-1 my-2 relative top-3 right-[1%]' style={dynamicSRDurationStyle} />
                            <div className='relative right-[2%]'>
                                <div class="circleborder" style={dynamicSRDurationStyle}><img src={ReplaceDelivered} className='srDurationStyleImg' /></div>
                                <p className='text-black text-[14px] text-center'>Delivered</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/* <div className='flex flex-col w-[30%] h-full items-center shadow-xl rounded-xl p-5 pb-10'>
                <p className='p-2 w-full text-black text-xl mb-5'>NPS Trend</p>
                <Chart  type='bar' options={npsTrendChartOptions} data={npsTrendChart} />
            </div> */}
            <div className={`flex flex-col items-center border border-[#D9D9D9] rounded-xl px-4 ${getCarrierByDomain()?.toLowerCase() === 'celcom' ? 'w-[49%]' : 'w-full'}`}>
                <p className='p-2 w-full text-[#363636] font-semibold text-xl mb-2'>Technical SLA</p>
                <div className='flex flex-row mx-2 items-start w-full'>
                    {/* Section for the left column */}
                    {/* <div className='flex flex-col mt-10 w-full mx-2'> */}
                    {getApplicableSections(carrierThemeData?.applicableSections, 'customerOnlineChart') &&
                        <div className='flex flex-col items-center justify-center SLASection w-full mt-3'>
                            <Progress
                                percent={technicalSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%']}
                                size={['100%', 40]}
                                strokeColor={customerSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': theme?.colors?.progressBar?.primaryColor, '100%': theme?.colors?.progressBar?.secodaryColor }}
                                format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                percentPosition={{
                                    align: technicalSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                    type: technicalSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                  }}
                            />
                            <p className='h-[30px] text-black text-[14px] text-center'>Customer Online Portal Uptime</p>
                        </div>
                        }
                        {getApplicableSections(carrierThemeData?.applicableSections, 'customerHotlineChart') &&
                                <div className='flex flex-col items-center justify-center SLASection w-full ml-3 mt-3'>
                                    <Progress
                                        percent={technicalSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%']}
                                        size={['100%', 40]}
                                        strokeColor={customerSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': 'black', '100%': 'black' }}
                                        format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                        percentPosition={{
                                            align: technicalSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                            type: technicalSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                          }}
                                    />
                                    <p className='h-[30px] text-black text-[14px] text-center'>Customer Hotline Service Uptime</p>
                                </div>

                            }
                        {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummarySRPortalAvailability') &&
                            <div className={`w-[24%] mr-5 flex flex-col items-center justify-center ${technicalSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                            <Progress
                                percent={technicalSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ActualSLA%']}
                                size={['100%', 40]}
                                strokeColor={customerSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': 'black', '100%': 'black' }}
                                format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                percentPosition={{
                                    align: technicalSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                    type: technicalSLA?.filter(v => v?.Category === 'Service Request Portal/ App')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                  }}
                            />
                            <p className='h-[30px] text-black text-[14px] mt-1 text-center'>Service Request Portal Availability</p>
                        </div>
                        }
                        {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummaryP2') &&
                            <div className={`w-[24%] mr-5 flex flex-col items-center justify-center ${technicalSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                                <Progress
                                    percent={technicalSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={customerSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': 'black', '100%': 'black' }}
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    percentPosition={{
                                        align: technicalSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                        type: technicalSLA?.filter(v => v?.Category === 'Priority 2 (P2) – Minor Incident')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                      }}
                                />
                                <p className='h-[30px] text-black text-[14px] mt-1 text-center'>P2 – Minor Incident</p>
                            </div>
                        }
                    {/* </div> */}

                    {/* Section for the middle column */}
                    {/* <div className='flex flex-col mt-10 w-full mx-2'> */}
                        {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummaryP1') &&
                            <div className={`w-[24%] mr-5 flex flex-col items-center justify-center ${technicalSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                                <Progress
                                    percent={technicalSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={customerSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': 'black', '100%': 'black' }}
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    percentPosition={{
                                        align: technicalSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                        type: technicalSLA?.filter(v => v?.Category === 'Priority 1 (P1) – Critical Incident')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                      }}
                                />
                                <p className='h-[30px] text-black text-[14px] mt-1 text-center'>P1 – Critical Incident</p>
                            </div>
                        }
                        {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummaryP3') &&
                            <div className={`w-[24%] mr-5 flex flex-col items-center justify-center ${technicalSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ActualSLA%'] > 0 ? 'SLASection' : 'SLASectionNA'}`}>
                                <Progress
                                    percent={technicalSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ActualSLA%']}
                                    size={['100%', 40]}
                                    strokeColor={customerSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': 'black', '100%': 'black' }}
                                    format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    percentPosition={{
                                        align: technicalSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ActualSLA%'] > 0 ? 'center' : undefined,
                                        type: technicalSLA?.filter(v => v?.Category === 'Priority 3 (P3) – Improvement')[0]?.['ActualSLA%'] > 0 ? 'inner' : undefined,
                                      }}
                                />
                                <p className='h-[30px] text-black text-[14px] mt-1 text-center'>P3 - Improvement</p>
                            </div>
                        }
                    {/* </div> */}

                    {/* Section for the right column */}
                    {/* {(getApplicableSections(carrierThemeData?.applicableSections, 'customerOnlineChart') || getApplicableSections(carrierThemeData?.applicableSections, 'customerHotlineChart')) &&
                        <div className='flex flex-col mt-10 w-full mx-2'>
                            {getApplicableSections(carrierThemeData?.applicableSections, 'customerOnlineChart') &&

                                <div className='flex flex-col items-center justify-center SLASection'>
                                    <Progress
                                        percent={technicalSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%']}
                                        size={['100%', 40]}
                                        strokeColor={customerSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Customer Online Portal Uptime')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': theme?.colors?.progressBar?.primaryColor, '100%': theme?.colors?.progressBar?.secodaryColor }}
                                        format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    />
                                    <p className='h-[30px] text-black text-[14px] text-center'>Customer Online Portal Uptime</p>
                                </div>

                            }
                            {getApplicableSections(carrierThemeData?.applicableSections, 'customerHotlineChart') &&
                                <div className='flex flex-col items-center justify-center mt-5 SLASection'>
                                    <Progress
                                        percent={technicalSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%']}
                                        size={['100%', 40]}
                                        strokeColor={customerSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ActualSLA%'] < customerSLA?.filter(v => v?.Category === 'Customer Hotline Service Uptime')[0]?.['ExpectedSLA%'] ? { '0%': '#E553D0', '100%': '#C800A1' } : { '0%': theme?.colors?.progressBar?.primaryColor, '100%': theme?.colors?.progressBar?.secodaryColor }}
                                        format={(percent) => percent === 0 ? 'NA' : `${percent}%`}
                                    />
                                    <p className='h-[30px] text-black text-[14px] text-center'>Customer Hotline Service Uptime</p>
                                </div>

                            }
                        </div>
                    } */}

                </div>
            </div>
        </div>
    )
}

export default ProgramSummary